/** Reusable placeholder for admin pages that aren't built yet. */
import { Sparkles } from "lucide-react";

export default function ComingSoon({ title, description }) {
    return (
        <div className="space-y-4" data-testid="admin-coming-soon">
            <header>
                <p className="font-mono-ui text-[10px] tracking-[0.18em] uppercase text-[#857C72]">Admin</p>
                <h1 className="font-display text-3xl sm:text-4xl mt-1">{title}</h1>
            </header>
            <div className="rounded-2xl border-2 border-dashed border-[#E7DED2] bg-white p-10 text-center">
                <Sparkles className="h-8 w-8 mx-auto text-[#857C72] mb-3" />
                <p className="font-display text-2xl mb-2">Coming soon</p>
                <p className="text-sm text-[#857C72] max-w-md mx-auto">
                    {description || "This page is on the roadmap — the navigation slot is reserved so links are consistent."}
                </p>
            </div>
        </div>
    );
}
